import { Form } from 'antd';
export default (function (decorated) {
    return Form.create()(decorated);
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/decorators/form.ts
// module id = 53
// module chunks = 0